/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Variance_WarningInputs */

const vi_stocktake_variance_warning = /** @type {(inputs: Stocktake_Variance_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lệch cao`)
};

/**

* @param {Stocktake_Variance_WarningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_variance_warning = /** @type {((inputs?: Stocktake_Variance_WarningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Variance_WarningInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_variance_warning(inputs)
});